// src/pages/Gallery.jsx
import React from 'react';
import './gallary.css'; // Make sure filename and path are correct

import person1 from '../assets/person1.jpg';
import person2 from '../assets/person2.jpg';
import person4 from '../assets/person4.jpg';
import person5 from '../assets/person5.jpg';
import person6 from '../assets/person6.jpg';
import person7 from '../assets/person7.jpg';
import person8 from '../assets/person8.jpg';
import person9 from '../assets/perosn9.jpg';
import person10 from '../assets/peroson10.jpg';
import person11 from '../assets/person11.jpg';

const galleryImages = [person1, person2, person5, person4, person6, person7,person8,person9,person10,person11];

const Gallery = () => {
  return (
    <div className="image-gallery-section">
      <h2>Image Gallery</h2>
      <p className="gallery-subtitle">Check out more photos from our products and events.</p>
      <div className="gallery-grid">
        {galleryImages.map((img, idx) => (
          <div className="gallery-card" key={idx}>
            <img src={img} alt={`Gallery ${idx + 1}`} className="gallery-image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
